import AffiliateTermsDialog from './AffiliateTermsDialog';

export default AffiliateTermsDialog;
